import { routeEnter } from '@containers/main/main-slice'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { AiModel, State } from './users-types'

export function getInitialState(): State {
  return {
    users: null,
    userManager: {
      open: false,
    },
    selected: [],
    selectAll: false,
    searchUser: '',
    userStats: null,
    sortParams: {
      column: '',
      order: 'asc',
    },
    count: 0,
    tickets: {},
  }
}

interface Item {
  aiModel: AiModel
}

export interface ModelData {
  id: string
  name: string
  owner: {
    id: string
    email: string
  }
  items: Item[]
}

export interface Model {
  projects: ModelData[]
}

export const slice = createSlice({
  name: 'users',
  initialState: getInitialState(),
  reducers: {
    set(state: State, action: PayloadAction<Partial<State>>) {
      Object.assign(state, action.payload)
    },
    increaseCount(state: State) {
      state.count += 1
    },
    setSelectedUser(state: State, action: PayloadAction<string>) {
      if (!state.selected.includes(action.payload)) state.selected.push(action.payload)
      else state.selected = state.selected.filter((x) => x !== action.payload)
    },
    setSortParams(state: State, action: PayloadAction<string>) {
      state.sortParams.column = action.payload
      state.sortParams.order = state.sortParams.order === 'asc' ? 'desc' : 'asc'
    },
    setTicket(state, action: PayloadAction<{ email: string; value?: string; loading: boolean }>) {
      const { email, loading, value } = action.payload
      state.tickets[email] = { loading, value }
    },
  },
  extraReducers: (builder) => {
    // clear some state when enter the page
    builder.addCase(routeEnter, (state: State, action) => {
      if (action.payload.path === '/users') {
        Object.assign(state, {
          searchUser: '',
          selected: [],
          sortParams: {
            column: '',
            order: 'asc',
          },
        })
      }
    })
  },
})

export default slice

export const { actions } = slice
